import { memo } from 'react';
import { IMatch } from '@zmedia/bm-soccer-ui/interface';
import { ColorUtils, ObjectUtils } from '@zmedia/bm-soccer-ui/utils';
import { unixToDate } from '@zmedia/bm-soccer-ui/utils/date';
import {
    Element,
    Image,
    Section,
    Title,
} from '@zmedia/bm-soccer-ui/components';
import { Team } from '../../components/team';
import { Score } from '../../components/score';
import styles from './style.module.scss';

export function HeadToHead(props: any) {
    const { h2h = {}, teamColor = {} } = props;

    if (ObjectUtils.isEmpty(h2h)) {
        return null;
    }

    const renderItem = (item: IMatch, index: number) => {
        return (
            <Element className={styles['match-item']} key={index}>
                <Element className={styles['match-ext-info']}>
                    <Element className={styles['match-tournament']}>
                        {item?.tournament?.name}
                    </Element>
                    <Element className={styles['match-date']}>
                        {unixToDate(item.startTime / 1000, 'DD [thg] MM, YYYY')}
                    </Element>
                </Element>
                <Team team={item.home.team} />
                <Score item={item} />
                <Team team={item.away.team} />
            </Element>
        );
    };

    const renderItems = (matches: IMatch[] = []) => {
        return matches.map((item, index) => {
            return renderItem(item, index);
        });
    };

    const { items = [], hwin, draw, awin } = h2h;
    const total = hwin + draw + awin;

    const percentHwin: number = +((hwin / total) * 100).toFixed(2);

    const percentDraw: number = +((draw / total) * 100).toFixed(2);
    const percentAwin: number = +(100 - percentHwin - percentDraw).toFixed(2);

    return (
        <Section
            className={styles['head-to-head-section']}
            name="match-head-to-head"
        >
            <Title>Đối đầu gần đây</Title>
            <Element className={styles['header-container']}>
                <Image src={props.home.team.logo} alt={props.home.team.name} />
                <Element className={styles['elo-container']}>
                    <Title>Số trận ({total})</Title>
                    <Element className={styles['elo-bar']}>
                        <Element
                            className={styles['home-bar']}
                            style={{ width: percentHwin + '%' }}
                        ></Element>
                        <Element
                            className={styles['draw-bar']}
                            style={{ width: percentDraw + '%' }}
                        ></Element>
                        <Element
                            className={styles['away-bar']}
                            style={{ width: percentAwin + '%' }}
                        ></Element>
                    </Element>
                    <Element className={styles['elo-info']}>
                        <Element className={styles['home-info']}>
                            <Element
                                className={styles['number']}
                                style={{
                                    color: !ColorUtils.isBrightnessColor(
                                        teamColor?.hColor
                                    )
                                        ? '#fff'
                                        : '',
                                }}
                            >
                                {hwin}
                            </Element>
                            <Element className={styles['text']}>
                                Thắng
                                <Element
                                    className={styles['percent']}
                                    style={{
                                        color: ColorUtils.isBrightnessColor(
                                            teamColor?.hColor
                                        )
                                            ? '#000'
                                            : '',
                                    }}
                                >
                                    {percentHwin}%
                                </Element>
                            </Element>
                        </Element>
                        <Element className={styles['draw-info']}>
                            <Element className={styles['number']}>
                                {draw}
                            </Element>
                            <Element className={styles['text']}>
                                Hòa
                                <Element className={styles['percent']}>
                                    {percentDraw}%
                                </Element>
                            </Element>
                        </Element>
                        <Element className={styles['away-info']}>
                            <Element
                                className={styles['number']}
                                style={{
                                    color: !ColorUtils.isBrightnessColor(
                                        teamColor?.aColor
                                    )
                                        ? '#fff'
                                        : '',
                                }}
                            >
                                {awin}
                            </Element>
                            <Element className={styles['text']}>
                                Thắng
                                <Element
                                    className={styles['percent']}
                                    style={{
                                        color: ColorUtils.isBrightnessColor(
                                            teamColor?.aColor
                                        )
                                            ? '#000'
                                            : '',
                                    }}
                                >
                                    {percentAwin}%
                                </Element>
                            </Element>
                        </Element>
                    </Element>
                </Element>
                <Image src={props.away.team.logo} alt={props.away.team.name} />
            </Element>
            <Element className={styles['match-items']}>
                {renderItems(items)}
            </Element>
        </Section>
    );
}

export default memo(HeadToHead);
